module.exports = __webpack_public_path__ + "media/A56.50f38d57.mp3";